import React from 'react'
import { IAttributeFieldProps } from './IAttributeField'

function AttributeFieldNumber({currValue, setCurrValue}: IAttributeFieldProps) {
  return (
    <input type="number" value={currValue} onChange={(e) => setCurrValue(e.target.value)} className="form-control mb-3" />
  )
}

export default AttributeFieldNumber